module.exports = __webpack_public_path__ + "static/06-55df689df43177a975308fbcdca4ddde.jpg";